if (!customElements.get('sn-cross-sell')) {
  customElements.define('sn-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button')?.addEventListener('click', () => this.add());
    }
    async add() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      const label = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.busy;
      status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: this.dataset.variant, quantity: 1}]})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        button.textContent = this.dataset.added;
        status.textContent = this.dataset.added;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        const checkout = this.closest('[data-cart-form]')?.querySelector('[name="checkout"]');
        checkout?.focus({preventScroll: true});
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        button.disabled = false;
        button.textContent = label;
        this.busy = false;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  });
}
